// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ../ext/select2-3.5.1/select2.css
 ** module id = 145
 ** module chunks = 0
 **/